import { updateProject, updateStatusChanged } from '../../../redux/actions/projects.actions';

const saveChanges = async (location, project_id, type, value, old_value, reason, dispatch, roles, pmId, setEditable, closeReason, billingChannelId) => {
  if (type === 'status') {
    // Use the dedicated status update function for status changes
    return dispatch(updateStatusChanged(project_id, value, location, closeReason));
  }
  // Continue with the existing project update logic for other types
  return dispatch(updateProject(location, project_id, type, value, old_value, dispatch, reason, roles, pmId, setEditable, billingChannelId));
};

export default saveChanges;
